import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { TherapistDto } from '@therapist/shared/models/therapist/therapist.dto';
import { TherapistRegisterDto } from '@therapist/shared/models/therapist/therapist-register.dto';
import { LoginDto } from '@base/models/login.dto';
import { UserApiService } from '@base/services/user-api.service';

@Injectable({ providedIn: 'root' })
export class TherapistApiService extends UserApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/therapist`;
  }

  protected get authEndpoint() {
    return `${environment.basePathAuthentication}`;
  }

  getProfile(): Observable<TherapistDto> {
    return this.#http.get<TherapistDto>(`${this.endpoint}/profile`);
  }

  register(therapistRegisterDto: TherapistRegisterDto): Observable<TherapistDto> {
    return this.#http.post<TherapistDto>(`${this.endpoint}/register`, therapistRegisterDto);
  }

  override submitLogin(email: string, password: string): Observable<LoginDto> {
    return this.#http.post<LoginDto>(`${this.authEndpoint}/login`, {
      email: email,
      password: password
    });
  }

  override requestPasswordReset(email: string): Observable<any> {
    return this.#http.post(`${this.authEndpoint}/password/request-reset-therapist`, { email: email });
  }

  override resetPassword(token: string, password: string): Observable<LoginDto> {
    return this.#http.post<LoginDto>(`${this.authEndpoint}/password/reset-therapist`, { token: token, newPassword: password });
  }
}
